






























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { RecruitmentChecklistMeta } from './model/RecruitmentChecklistMeta'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'

const userStore = namespace('UserStore')

@Component
export default class TheRecruitmentChecklist extends Vue {
  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta;

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  get recruitmentChecklist () {
    return this.userAdviserDetails.recruitmentChecklist
  }

  protected recruitmentChecklistRows: Array<{
    checkKey: keyof UserAdviserDetailsMeta;
    criteria: string;
    requirements: string;
    remarksKey: keyof RecruitmentChecklistMeta;
  }> = [
    {
      checkKey: 'atLeast21Checked',
      criteria: 'Minimum Age',
      requirements: 'At least 21 years old',
      remarksKey: 'atLeast21Remarks'
    },
    // Temporary commenting it out so that SingCap can view what they required
    // {
    //   checkKey: 'atLeast4GceChecked',
    //   criteria: 'Education Qualification',
    //   requirements: "At least 4 GCE 'O' Level credits",
    //   remarksKey: 'atLeast4GceRemarks'
    // },
    {
      checkKey: 'aLvlChecked',
      criteria: 'Education Qualification',
      requirements: 'At least 5 \'A\' level credits or Equivalent Qualification',
      remarksKey: 'aLvlCheckedRemarks'
    },
    {
      checkKey: 'examRequirementsChecked',
      criteria: 'Examination Requirements',
      requirements: 'Life Insurance passed M5 & M9',
      remarksKey: 'examRequirementsRemarks'
    },
    {
      checkKey: 'examRequirements2Checked',
      criteria: 'Examination Requirements',
      requirements: 'Life Insurance passed M8 & M8A',
      remarksKey: 'examRequirements2Remarks'
    },
    {
      checkKey: 'examRequirements3Checked',
      criteria: 'Examination Requirements',
      requirements: 'Life Insurance passed M6 & M6A',
      remarksKey: 'examRequirements3Remarks'
    },
    {
      checkKey: 'examRequirements4Checked',
      criteria: 'Examination Requirements',
      requirements: 'Life Insurance passed M1 & M1B',
      remarksKey: 'examRequirements4Remarks'
    },
    {
      checkKey: 'examRequirements5Checked',
      criteria: 'Examination Requirements',
      requirements: 'GI Insurance passed BCP, CGI, & PGI',
      remarksKey: 'examRequirements5Remarks'
    },
    {
      checkKey: 'solvencySearchChecked',
      criteria: 'Fit & Proper',
      requirements: 'Solvency Search',
      remarksKey: 'solvencySearchRemarks'
    },
    {
      checkKey: 'contractStatusChecked',
      criteria: 'Fit & Proper',
      requirements: 'Exempt FA and FA check - Contract Status',
      remarksKey: 'contractStatusRemarks'
    },
    {
      checkKey: 'marketConductChecked',
      criteria: 'Fit & Proper',
      requirements: 'Exempt FA and FA check - Market Conduct',
      remarksKey: 'marketConductRemarks'
    },
    {
      checkKey: 'employerChecked',
      criteria: 'Fit & Proper',
      requirements: 'Employer Check',
      remarksKey: 'employerRemarks'
    },
    {
      checkKey: 'masProhibitionCheckChecked',
      criteria: 'Fit & Proper',
      requirements: 'MAS Prohibition Order Check',
      remarksKey: 'masProhibitionCheckRemarks'
    }
  ];

  // @Watch('loading')
  // watchLoading (newValue: boolean) {
  //   if (!newValue) {
  //     this.updateRecruitmentChecklistRows()
  //   }
  // }

  // updateRecruitmentChecklistRows () {
  //   this.recruitmentChecklistRows.forEach((recruitmentChecklist: RecruitmentChecklistInterface) => {
  //     recruitmentChecklist.checked = !!this.userAdviserDetails[
  //       recruitmentChecklist.key + '_checked'
  //     ]
  //     recruitmentChecklist.remarks = this.userAdviserDetails.recruitment_checklist[
  //       recruitmentChecklist.key + '_remarks'
  //     ]
  //   })
  // }
}
